import $ from 'jquery';
import SiteMegamenu from './site-megamenu';
import { qs } from '@/utils/dom';
const { hash, pathname } = window.location;
const Classify = {
    init: () => {
        const classifyTab = document.getElementById("products-tab");
        if (classifyTab === null)
            return;
        Classify.load();
        Classify.detectHash(classifyTab);
        Classify.switchTab(classifyTab);
        Classify.toggleDownloadPDF();
        // if route product and no hash append the default hash
        // and active the defautl link
        if (!hash) {
            const [, , pathnameProductds] = pathname.split('/');
            if (pathnameProductds && pathnameProductds === 'products') {
                Classify.updateHash('#egg-production');
                SiteMegamenu.initActive($('.site-header'));
            }
        }
    },
    switchTab: (tabElement) => {
        tabElement.addEventListener("shown.bs.tab", (event) => {
            const target = event.target;
            const { bsTarget, project } = target.dataset;
            Classify.toggleDownloadPDF();
            Classify.updateHash(bsTarget);
            Classify.updateProject(project);
            Classify.updateBadgeNavLink(bsTarget);
        });
    },
    toggleDownloadPDF: () => {
        const $classifyTab = $("#products-tab");
        const $sectionDownload = $('.section-download');
        const $activeNavLink = $classifyTab.find('.nav-link.active');
        const activeNavLinkData = $activeNavLink.data();
        if (!activeNavLinkData.pdfDownload) {
            $sectionDownload.addClass('d-none');
        }
        else {
            $sectionDownload.removeClass('d-none');
            $sectionDownload.find('a').attr('href', `/${activeNavLinkData.pdfDownload}`);
        }
    },
    updateHash: (hash) => {
        history.pushState({}, "", hash);
    },
    load: () => {
        $(window).on('load', () => {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
        });
    },
    detectHash: (tabElement) => {
        const selectedLink = tabElement.querySelector(`[data-bs-target="${hash}"]`);
        if (selectedLink == null)
            return;
        selectedLink.click();
    },
    updateProject: (project) => {
        const $businessUnitProject = qs(".business-unit-project");
        if ($businessUnitProject === null)
            return;
        const projectParsed = JSON.parse(project);
        qs(".business-unit-project-title", $businessUnitProject).textContent = projectParsed.title;
        qs(".business-unit-project-description", $businessUnitProject).innerHTML = projectParsed.content;
        qs(".business-unit-project-link", $businessUnitProject).setAttribute("href", projectParsed.url);
        qs(".business-unit-project-img", $businessUnitProject).setAttribute("src", projectParsed.image);
    },
    updateBadgeNavLink: (bsTarget) => {
        // update desktop
        $('.megamenu-badge a').each((index, link) => {
            const linkHref = $(link).attr('href');
            if (linkHref.includes(bsTarget)) {
                $(link).parents('li').siblings().removeClass('is-selected').removeClass('is-exact');
                $(link).parents('li').addClass('is-selected').addClass('is-exact');
            }
        });
        // update mobile
        $('.megamenu-level2 > li > a').each((index, link) => {
            const linkHref = $(link).attr('href');
            if (linkHref.includes(bsTarget)) {
                $(link).parents('li').siblings().removeClass('is-current');
                $(link).parents('li').addClass('is-current');
            }
        });
    }
};
export default Classify;
